import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getFullPath, routes } from "@/features/custom/williams/routes";
import { HTMLAttributes, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Portal } from "@/components";
import { useConfiguration } from "@/queries/configuration.queries";
import { useLogin, useLostFocus } from "@/hooks";
import { useMenuOptions } from "./hooks/useMenuOptions";

import styles from "./HamburgerMenu.module.scss";

export function HamburgerMenu(props: HTMLAttributes<HTMLDivElement>) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const options = useMenuOptions();
  const config = useConfiguration();
  const location = useLocation();
  const login = useLogin();

  // Close on lost focus.
  const menuRef = useRef(null);
  useLostFocus(menuRef, () => setIsOpen(false));

  // Close on link clicked.
  useEffect(() => setIsOpen(false), [location]);

  function onLogout(e: React.MouseEvent) {
    e.preventDefault();
    login.logout();
  }

  return (
    <>
      <FontAwesomeIcon icon={faBars} role="button" onClick={() => setIsOpen(true)} />

      <Portal target="portal-root">
        <nav ref={menuRef} className={isOpen ? styles.visible : styles.hidden} {...props}>
          <FontAwesomeIcon role="button" icon={faClose} className="float-end" onClick={() => setIsOpen(false)} />

          <h4 className={styles.header}>Menu</h4>
          <ul className={styles.links}>
            {options
              .filter((x) => x.visible)
              .map((props, index) => (
                <li key={index}>
                  <Link to={props.to}>{props.title}</Link>
                </li>
              ))}
            <li>
              <hr />
            </li>
            {config.data?.qualifier?.isWilliams ? (
              <>
                <li>
                  <Link to={getFullPath(routes.miscellaneous.help)}>Help</Link>
                </li>
                <li>
                  <Link to={getFullPath(routes.miscellaneous.settings)}>Settings</Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/settings">Settings</Link>
                </li>
              </>
            )}

            <li>
              <a href="#" onClick={onLogout}>
                Log out ({config.data?.currentUser})
              </a>
            </li>
          </ul>
        </nav>
      </Portal>
    </>
  );
}
